const styleMap = {
  "nmos": 'shape=nmos;labelPosition=center;verticalLabelPosition=top;align=center;verticalAlign=bottom;fontColor=#000000',
  "pmos": 'shape=pmos;labelPosition=center;verticalLabelPosition=top;align=center;verticalAlign=bottom;fontColor=#000000',
  "no-conn": 'shape=no-conn;labelPosition=top;verticalLabelPosition=top;align=right;verticalAlign=top;fontColor=#000000;spacingTop=-10;fontSize=10'
};

export function removeMxGraphWrappers(xmlString) {
  return xmlString; // Quick fix, Issue need to address 
  try {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, "text/xml");

    // Extract all <mxCell> elements inside <root>
    const cells = xmlDoc.getElementsByTagName("root")[0]?.children;
    if (!cells) return "";

    // Serialize only the inner content of <root>
    let innerXML = "";
    for (let cell of cells) {
      innerXML += new XMLSerializer().serializeToString(cell);
    }

    return innerXML;
  } catch (error) {
    console.error("Error removing mxGraphModel/root:", error);
    return xmlString;
  }
}

export function wrapMxGraphModel(innerXML) {
  return innerXML;
  try {
    return `<mxGraphModel><root>${innerXML}</root></mxGraphModel>`;
  } catch (error) {
    console.error("Error wrapping mxGraphModel/root:", error);
    return innerXML;
  }
}

export function extractAndRemoveStyles(xmlString) {
  return {
    cleanedXml: xmlString,
    styleMap: {}
  };
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xmlString, "text/xml");
  const cells = xmlDoc.getElementsByTagName("mxCell");

  const styleMap = {}; // to store extracted styles

  Array.from(cells).forEach(cell => {
    const id = cell.getAttribute("id");
    const style = cell.getAttribute("style");
    const isShape = cell.getAttribute("vertex") === "1";
    if (id && style && isShape) {
      styleMap[id] = style;   // save style separately
      cell.removeAttribute("style"); // remove from XML
    }
  });

  const cleanedXml = new XMLSerializer().serializeToString(xmlDoc);
  return { cleanedXml, styleMap };
}

export function addStylesBackToXml(cleanedXml) {
  return cleanedXml;

  // Parse cleaned XML string
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(cleanedXml, "application/xml");

  const cells = xmlDoc.querySelectorAll("mxCell");
  cells.forEach(cell => {
    let shapeType = cell.getAttribute("shapeType");

    if (!shapeType) {
      const existingStyle = cell.getAttribute("style");
      if (existingStyle && existingStyle.includes("shape=")) {
        shapeType = existingStyle.match(/shape=([^;]+)/)?.[1];
      }
    }

    if (shapeType && styleMap[shapeType]) {
      cell.setAttribute("style", styleMap[shapeType]);
    }
  });

  const serializer = new XMLSerializer();
  const styledXml = serializer.serializeToString(xmlDoc);

  return styledXml;
}